import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import { withRouter } from 'react-router-dom';

import version from '../../../../package.json';

import Item from './Item';
import Header from './Header';
import Divider from './Divider';

import { bindActionCreators } from 'redux';
import * as actionsSession from '../../../actions/session.actions';

// eslint-disable-next-line
import style from './_style.css';

class Index extends React.Component {
    handleClose = (id, e) => {
        this.props.onClose();
        switch (id) {
            case 0:
                this.props.history.push('/user/pin');
                break;
            case 1:
                this.props.logOutUser();
                this.props.history.push('/logout');
                break;
            case 2:
                document.location.href = 'mailto:soporte@iflares.com';
                break;
            case 3:
                this.props.setTutorial(true);
                break;
            default:
                break;
        }
    };

    render() {
        const { anchorEl } = this.props;
        return (
            <div>
                <Drawer
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    classes={{
                        paper: 'navbar-menu',
                    }}
                    className={'z_index_dialog'}
                >
                    <List className={'navbar-list flex_full_column'}>
                        <Header />
                        <Item secondary="area_drawer" />
                        <ListItem>
                            <Item
                                primary="change_pin_drawer"
                                onClick={(e) => this.handleClose(0, e)}
                            />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item
                                primary="session_drawer"
                                onClick={(e) => this.handleClose(1, e)}
                            />
                        </ListItem>
                        {/*
                        <Item secondary="manage_drawer" />
                        <ListItem>
                            <Item
                                primary="set_pin_drawer"
                                onClick={(e) => this.handleClose(0, e)}
                            />
                        </ListItem>
                        */}

                        <Item secondary="general_drawer" />
                        <ListItem>
                            <Item
                                primary="comments_drawer"
                                onClick={(e) => this.handleClose(2, e)}
                            />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item
                                primary="tutorial"
                                onClick={(e) => this.handleClose(3, e)}
                            />
                        </ListItem>
                        {/*
                        <Divider />
                        <ListItem>
                            <Item
                                primary="language_drawer"
                                onClick={(e) => this.handleClose(0, e)}
                            />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item primary="sugestions_drawer" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item primary="faq_drawer" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item primary="zone_drawer" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <Item primary="device_drawer" />
                        </ListItem>
                        */}
                    </List>
                    <div className={'barlow_regular_subtitle padding_borders_equals'}>
                        {version.version}
                    </div>
                </Drawer>
            </div>
        );
    }
}
Index.propTypes = {
    history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        session: state.session,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsSession), dispatch);
};

Index = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Index);

Index = withRouter(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/navbar/user/Menu.js